<script>
    

import SubTabItem from './SubTabItem.svelte';
    import DropDown from '#form/DropDown.svelte';
    import { createEventDispatcher, onMount } from 'svelte';
    import { UID } from '@repo/config/Utils';
    import { goto } from '$app/navigation';
    /**
     * @typedef {Object} Props
     * @property {any} [items]
     * @property {any} selected
     * @property {string} [background]
     * @property {string} [color]
     * @property {boolean} [links]
     * @property {boolean} [collapsable]
     */
    let {
        items = [],
        selected = $bindable(),
        background = 'rgb(255, 206, 44)',
        color = 'black',
        links = false,
        collapsable = true,
        ariaLabel = null,
    } = $props();

    const dispatch = createEventDispatcher();

    const id = UID();
    let bar = $state(null);
    let dropdown = $state(null);
    let collapse = $state(false);
    
    let options = $state([]);

    options = [];
    items.forEach((i) => {
        options.push({
            displayName: i.title,
            name: i.sectionID,
            action: i.sectionID,
        });
    });

    function handleTabSelected(e) {
        document
            .querySelectorAll('.sub-tab-item')
            .forEach((n) => n.classList.remove('selected'));
        e.detail.classList.add('selected');
        dispatch('selected', e.detail);
        selected = e.detail.dataset.sectionid;
    }

    async function handleWindowResize() {
        if (!collapsable) return;

        collapse = bar?.scrollWidth >= bar?.getBoundingClientRect()?.width + 10; // 10 is for a small buffer
    }

    function handleDropDownChange(e) {
        goto(`${e.detail.value}`);
    }

    onMount(() => {
        handleWindowResize();
    });

    $effect(() => {
        handleWindowResize();
    });
</script>

<svelte:window onresize={handleWindowResize} />

<div id={id} class="sub-tabs {collapse ? 'collapsed' : ''} {items.length === 0 ? 'empty' : ''}" style="background-color:{background}; color:{color};">
    {#if items.length > 0}
        <ul bind:this={bar} class="bar {collapse ? 'hide' : ''}">
            {#each items as item}
                <SubTabItem on:selected={handleTabSelected} title={item.title} description={item.description} sectionID={item.sectionID} selected={item.sectionID === selected} link={links} />
            {/each}
        </ul>
    {/if}
    {#if collapse}
        <div bind:this={dropdown} class="drop-down">
            {#key selected}
                <DropDown
                    onchange={handleDropDownChange}
                    {options}
                    color="black"
                    backgroundColor="transparent"
                    value={selected}
                    bold={true}
                    {ariaLabel}
                />
            {/key}
        </div>
    {/if}
</div>

<style>
    .sub-tabs {
        display: flex;
        box-sizing: border-box;
        flex-direction: row;
        align-items: center;
        color: black;
        height: 3.5rem;
        flex-grow: 0;
        padding-bottom: 0.5rem;
        width: 100%;
    }

    .sub-tabs.empty {
        height: 0.5rem;
    }

    .sub-tabs.collapsed {
        width: calc(100% - var(--collapse-buffer));
    }

    .bar {
        position: relative;
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        width: 100%;
        margin-left: 1.5rem;
        align-items: center;
        overflow: hidden;
    }

    .bar.hide {
        position: absolute;
        left: -10000px;
    }

    .drop-down {
        padding: 0.5rem 0 0 0.5rem;
    }
</style>
